/* eslint-disable prettier/prettier */
import { useCallback, useState } from 'react';

import {
	fetchLessonDetail,
	LessonDetail,
	MarkAttendanceParticipant,
	markLessonAttendance,
} from '../services/schedule.service';

export function useLessonAttendance() {
	const [lesson, setLesson] = useState<LessonDetail | null>(null);

	const [loading, setLoading] = useState(false);

	const [attendanceLoading, setAttendanceLoading] = useState(false);

	const [error, setError] = useState<string | null>(null);

	/* =========================
       GET LESSON DETAIL
    ========================= */

	const getLessonDetail = useCallback(async (lessonId: string) => {
		try {
			setLoading(true);
			setError(null);

			const data = await fetchLessonDetail(lessonId);

			setLesson(data);

			return data;
		} catch (err: any) {
			setError(err.message || 'Something went wrong');
			return null;
		} finally {
			setLoading(false);
		}
	}, []);

	/* =========================
       MARK ATTENDANCE
    ========================= */

	const submitAttendance = useCallback(
		async (lessonId: string, participants: MarkAttendanceParticipant[]) => {
			try {
				setAttendanceLoading(true);
				setError(null);

				const res = await markLessonAttendance(lessonId, participants);

				// refresh lesson detail after update
				await getLessonDetail(lessonId);

				return res;
			} catch (err: any) {
				setError(err.message || 'Failed to mark attendance');
				throw err;
			} finally {
				setAttendanceLoading(false);
			}
		},
		[getLessonDetail]
	);

	return {
		lesson,

		loading,
		attendanceLoading,

		error,

		getLessonDetail,
		submitAttendance,
	};
}
